export const API_BASE_URL = "https://arbitrage-services.ru/api"
export const SOCKET_URL = "wss://arbitrage-services.ru"
